/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Not_Found_DescriptionInputs */

const fr_reference_not_found_description = /** @type {(inputs: Reference_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet élément n’est plus disponible. Actualisez la page.`)
};

const en_reference_not_found_description = /** @type {(inputs: Reference_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This item is no longer available. Refresh the page.`)
};

/**
* | output |
* | --- |
* | "This item is no longer available. Refresh the page." |
*
* @param {Reference_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const reference_not_found_description = /** @type {((inputs?: Reference_Not_Found_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Not_Found_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reference_not_found_description(inputs)
	return fr_reference_not_found_description(inputs)
});